
import Vue, { PropType } from "vue";
import KFieldGroup from "@/components/crud/fields/KFieldGroup.vue";
import { mapGetters } from "vuex";
import StockBatchStatusSelect from "@/modules/stock/components/StockBatchReportStatusSelect.vue";

type ComponentData = {
  internalFilters: Record<string, any>;
};

export default Vue.extend({
  name: "StockBatchReportFilter",
  components: {
    StockBatchStatusSelect,
    KFieldGroup,
  },
  props: {
    filters: {
      type: Object as PropType<Record<string, any>>,
      required: true,
    },
  },
  data: (): ComponentData => ({
    internalFilters: {
      status: undefined,
    },
  }),
  computed: {
    ...mapGetters("authorisation", ["client"]),
  },
  watch: {
    filters: {
      handler(newFilters) {
        this.internalFilters = newFilters;
      },
      immediate: true,
      deep: true,
    },
    internalFilters: {
      handler(newFilters) {
        this.$emit("update:filters", newFilters);
      },
      deep: true,
    },
  },
});
